var map = {
	"./recipes.ar.json": [
		167,
		167
	],
	"./recipes.de.json": [
		6747,
		6747
	],
	"./recipes.en.json": [
		8048
	],
	"./recipes.es.json": [
		1214,
		1214
	],
	"./recipes.fr.json": [
		564,
		564
	],
	"./recipes.ja.json": [
		2450,
		2450
	],
	"./recipes.ko.json": [
		901,
		901
	],
	"./recipes.pt.json": [
		5889,
		5889
	],
	"./recipes.ru.json": [
		7236,
		7236
	],
	"./recipes.zh.json": [
		3276,
		3276
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 641;
module.exports = webpackAsyncContext;